import FirebaseContext from './context';
import Firebase from './firebase';
import { withFirebase } from './withFirebase';

export default Firebase;

export { FirebaseContext, withFirebase };
